import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { cbDrawerComponent } from '@core/components/drawer/drawer.component';

@NgModule({
    declarations: [
        cbDrawerComponent
    ],
    imports     : [
        CommonModule
    ],
    exports     : [
        cbDrawerComponent
    ]
})
export class cbDrawerModule
{
}
